//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      formInline: {
        orgName: '',
        orgNum: ''
      },
      // defaultProps: {
      //   children: 'children',
      //   label: 'label'
      // },
      // data: [{
      //   label: '一级 1',
      //   children: [{
      //     label: '二级 1-1',
      //     children: [{
      //       label: '三级 1-1-1'
      //     }]
      //   }]
      // }, {
      //   label: '一级 2',
      //   children: [{
      //     label: '二级 2-1',
      //     children: [{
      //       label: '三级 2-1-1'
      //     }]
      //   }, {
      //     label: '二级 2-2',
      //     children: [{
      //       label: '三级 2-2-1'
      //     }]
      //   }]
      // }, {
      //   label: '一级 3',
      //   children: [{
      //     label: '二级 3-1',
      //     children: [{
      //       label: '三级 3-1-1'
      //     }]
      //   }, {
      //     label: '二级 3-2',
      //     children: [{
      //       label: '三级 3-2-1'
      //     }]
      //   }]
      // }],
      selectdData: [{
        title: '105230/深圳分行'
      }, {
        title: '105232/深圳分行'
      }]
    };
  },
  methods: {
    searchFn: function searchFn() {},
    delOrgFn: function delOrgFn() {},
    cancelFn: function cancelFn() {},
    commitFn: function commitFn() {}
  }
};